import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'lib-distribution-send-assessment-name-modal',
  templateUrl: './distribution-send-assessment-name-modal.component.html',
  styleUrls: ['./distribution-send-assessment-name-modal.component.scss']
})
export class DistributionSendAssessmentNameModalComponent implements OnInit {
  public name: string;
  public defaultName: string = this.translateService.instant('distribution.assessmentNameInputPlaceholder', {date: this.datePipe.transform(Date.now(), 'MM/dd/yyyy')});

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public translateService: TranslateService,
              public datePipe: DatePipe) {
  }

  ngOnInit(): void {
    this.name = this.defaultName;
  }

  cancel() {
    this.dynamicDialogRef.close(false);
  }

  sendAssessment() {
    this.dynamicDialogRef.close({name: this.name});
  }
}
